import React from 'react'

import { Box, Typography, CircularProgress } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import { useBrand } from '~/brand'

interface CustomCircularProgressProps {
  showMessage?: boolean
  size?: number | string
  classes?: { [key: string]: string }
  color?: 'inherit' | 'primary' | 'secondary'
  disableShrink?: boolean
  thickness?: number
  value?: number
  variant?: 'determinate' | 'indeterminate' | 'static'
}

const useStyles = makeStyles(() => {
  return {
    msg: {
      opacity: '0',
      animation: '$cssAnimation 0s 3s forwards',
    },
    '@keyframes cssAnimation': {
      to: {
        opacity: '1',
      },
    },
  }
})

const CustomCircularProgress: React.FC<CustomCircularProgressProps> = ({
  showMessage = true,
  color = 'primary',
  size,
  classes,
  disableShrink,
  thickness,
  value,
  variant,
}) => {
  const useStylesclasses = useStyles()
  const { brand } = useBrand()
  return (
    <Box
      display="flex"
      mt={10}
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      width="inherit"
    >
      <CircularProgress
        color={color}
        size={size}
        classes={classes}
        disableShrink={disableShrink}
        thickness={thickness}
        value={value}
        variant={variant}
      />
      {showMessage && (
        <Box display="flex" mt={5} className={useStylesclasses.msg}>
          <Typography
            variant="h5"
            align="center"
            color={brand === 'masmovil' ? 'secondary' : color}
          >
            Seguimos cargando los datos. Por favor, espera...
          </Typography>
        </Box>
      )}
    </Box>
  )
}

export default CustomCircularProgress
